import { render } from "./subject_dashboard.vue?vue&type=template&id=9ac60b22&scoped=true"
import script from "./subject_dashboard.js?vue&type=script&lang=js"
export * from "./subject_dashboard.js?vue&type=script&lang=js"

import "./subject_dashboard.vue?vue&type=style&index=0&id=9ac60b22&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ac60b22"]])

export default __exports__